var CourseSettingsService = require('services/course-settings-service');
var LocaleService = require('services/locale-service');
var utils = require('lib/utils');

var AudioService = {
  initialize: function(){
    this.sounds = {};
    createjs.Sound.on('fileload', this.onload, this);
    createjs.Sound.alternateExtensions = ["ogg"];
  },
  load: function (audioId, options) {
    this.options = options || {};
    var deferred = $.Deferred();
    if (this.sounds[audioId] instanceof createjs.AbstractSoundInstance){
      return deferred.resolve(this.sounds[audioId]);
    } else {
      this.sounds[audioId] = deferred;

      if (this.options.audioPath){
        //if path is provided, should be shared file that hasn't been LFSed
        createjs.Sound.registerSound(`${this.options.audioPath}/${audioId}.mp3`, audioId);
      } else {
        //request the relative audio file and see if it's an LFS stub
        var audioPath = this.options.loadPath ? utils.coursePath(this.options.loadPath) : utils.coursePath(`audio/${LocaleService.getLanguage()}/${audioId}.mp3`);
        $.ajax(audioPath, { dataType: 'text' })
          .then((body, status, xhr) => {
            if (xhr.getResponseHeader('Content-Type') === 'application/vnd.git-lfs+json'){
              var lfsData = body.split('\n');
              var oidSha = lfsData[1].split(' ')[1].replace('sha256:', '');
              audioPath = `${CourseSettingsService.get('media_host')}/curriculums/${CourseSettingsService.get('name')}`+
                `/media/audio/${LocaleService.getLanguage()}/${oidSha}.mp3`;
            }
            createjs.Sound.registerSound(audioPath, audioId);
          });
      }
      return deferred.promise();
    }
  },
  loadFakeAudio: function(){
    return this.load('point1sec', {
      audioPath: `${CourseSettingsService.get('media_host')}/shared/audio/${LocaleService.getLanguage()}`
    });
  },
  onload: function(event){
    var deferred = this.sounds[event.id];
    this.sounds[event.id] = createjs.Sound.createInstance(event.id);
    //TODO: on SoundJS update, should be able to remove this
    //https://github.com/CreateJS/SoundJS/issues/182
    this.sounds[event.id].pan = 0.0001;
    if (deferred.resolve) {
      return deferred.resolve(this.sounds[event.id]);
    }
  },
  unload: function(audioId){
    delete this.sounds[audioId];
    createjs.Sound.removeSound(audioId);
  }
};

module.exports = AudioService;
